import React, { Dispatch, useCallback } from 'react';

import { EnrollBgText } from '../../../containers/Enroll/Enroll.constants';
import {
  EnrollProgressBarBackSectionAction,
  EnrollProgressBarNextQuestionAction,
} from '../../../reducers/EnrollProgressBar/EnrollProgressBarReducer.constants';
import TransitionScreen from '../../TransitionScreen/TransitionScreen';
import EnrollLayout from '../EnrollLayout/EnrollLayout';

type Props = {
  isBackButtonDisabled?: boolean;
  progressBarDispatch: Dispatch<{ type: string }>;
}

const EnrollTransitionScreen = (props: Props) => {
  const {
    isBackButtonDisabled,
    progressBarDispatch,
  } = props;

  const onContinue = useCallback(() => {
    progressBarDispatch({ type: EnrollProgressBarNextQuestionAction });
  }, [progressBarDispatch]);

  const onBack = useCallback(() => {
    progressBarDispatch({ type: EnrollProgressBarBackSectionAction });
  }, [progressBarDispatch]);

  return (
    <EnrollLayout
      isBackButtonDisabled={isBackButtonDisabled}
      hiddenInlineHelp
      visibleContinueButton
      onBackButtonClicked={onBack}
      onContinueClicked={onContinue}
      continueButtonText={EnrollBgText.continueBtn}
      isTransitionScreen
      secondaryRowContent={(
        <TransitionScreen />
      )}
    />
  );
};

export default EnrollTransitionScreen;
